<template lang="pug">
  y-dialog(v-model="showDialog" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600" persistent scrollable content-class="round-3xl")
    v-card
      v-card-title.pa-4
        v-row(no-gutters align="center")
          v-col(cols="10" offset="1")
            div.text-xl.font-bold.neutral700--text.text-center {{ $t('create_input_field') }}
          v-col(cols="1" align="right")
            v-btn.ml-n3(text icon @click="closeDialog")
              v-icon(color="neutral700" :size="24") mdi-close

      v-divider
      v-card-text(:class="$vuetify.breakpoint.xsOnly ? 'pa-4' : 'pa-8'")
        div.text-md.font-semibold.neutral700--text {{ $t('fill_the_information_below') }}

        .form-input
          v-form(ref="form")
            div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('input_type') }}
            v-select.text-sm.mt-2.round-xl.hehe(v-model="form.datatype" :items="dataTypes" item-text="text" item-value="value" :placeholder="$t('select_input_type')" outlined :rules="rules.not_empty_select" hide-details="auto" dense append-icon="$yzi-chevron-down" :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', contentClass: 'select-menu' }")
            div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('label_title_of_question') }}
            v-text-field.text-sm.mt-2.round-xl(v-model="form.field_name" :placeholder="$t('enter_label_name')" outlined :rules="rules.not_empty" hide-details="auto" dense)
            .list-answer
              template(v-if="form.datatype === 'selection'")
                div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('list_of_answers') }}
                v-row.mt-2(v-for="(choice, cindex) in choices" no-gutters :key="'choice-' + cindex")
                  v-col
                    v-text-field.text-sm.round-xl(v-model="choice.text" :placeholder="$t('enter_label_name')" outlined :rules="rules.not_empty" hide-details="auto" dense)
                  v-col.shrink(v-if="cindex !== 0")
                    v-btn.ml-3(icon small @click="removeItem(choice)" style="margin-top: 6px")
                      v-icon(color="neutral700") $yzi-trash-03
                v-btn.button-xs.mt-2(color="neutral700" outlined @click="addItem")
                  v-icon(color="neutral700" left) $yzi-plus
                  | {{ $t('add_answer') }}
            div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('placeholder') }}
            v-text-field.text-sm.mt-2.round-xl(v-model="form.placeholder" :placeholder="$t('enter_placeholder')" outlined :rules="rules.not_empty" :hint="$t('placeholder_desc')" persistent-hint dense)
            y-checkbox.mt-4(v-model="form.required")
              template(#label)
                div.text-sm.neutral700--text.ml-2 {{ $t('is_required') }}

      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        v-btn.button-md.neutral700--text.px-0(@click="closeDialog" text) {{ $t('cancel') }}
        v-spacer
        v-btn.button-md(:loading="isLoading" color="neutral700" depressed dark @click="saveData") {{ $t('save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AddFieldDialog',
  props: ['open', 'field'],
  data () {
    return {
      isLoading: false,
      form: {},
      choices: [{ text: null }],
      dataTypes: [
        { text: 'Text', value: 'string' },
        { text: 'Selection input', value: 'selection' },
        { text: 'Phone number', value: 'phone' },
        { text: 'Number only', value: 'number' },
        { text: 'Address', value: 'address' },
        { text: 'Text area field', value: 'text' }
      ],
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    }
  },
  mounted () {
    if (this.field) {
      this.setData()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      this.form = this.field
      if (this.form.datatype === 'selection') {
        this.choices = this.form.extra_options.choices.map(m => { return { text: m } })
      }
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      if (this.form.datatype === 'selection') {
        this.form.extra_options = {
          choices: this.choices.map(m => m.text)
        }
      } else {
        this.form.extra_options = {}
      }
      if (this.field) {
        this.$axios.put(`/clinics/${this.company.slug}/form_fields/${this.field.idx}`, this.form)
          .then(() => {
            this.$emit('updated')
            this.showDialog = false
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.$axios.post(`/clinics/${this.company.slug}/form_fields`, this.form)
          .then(() => {
            this.$emit('updated')
            this.showDialog = false
          })
          .catch((err) => {
            this.showMessage(['error', err?.response?.data[0] || this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    addItem () {
      this.choices.push({ text: null })
    },
    removeItem (choice) {
      this.choices = this.choices.filter(f => f !== choice)
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>